import { render, staticRenderFns } from "./financialControl.vue?vue&type=template&id=ddbead82&scoped=true&"
import script from "./financialControl.vue?vue&type=script&lang=js&"
export * from "./financialControl.vue?vue&type=script&lang=js&"
import style0 from "./financialControl.vue?vue&type=style&index=0&id=ddbead82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbead82",
  null
  
)

export default component.exports